<template>
  <div class="selectPatient">
    <div class="patient">请选择就诊人:</div>
    <div class="patientCell">
      <van-cell
        v-for="item in patientList"
        :key="item.idCard"
        class="patientVanCell"
        is-link
        :title="item.name"
        @click.native="onSelect"
      />
    </div>
    <div class="verificationCode">
      <van-button type="default" @click.native="onClick">查询其他就诊人</van-button>
    </div>
    <van-button
      type="default"
      style="width:20px;float:right;margin-top:300px;background:#efefef"
      @click.native="onForwarding"
    ></van-button>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  props: ['patientList'],
  data() {
    return {}
  },
  methods: {
    onCancel() {
      Toast('取消')
    },
    onSelect() {
      this.$router.push({ path: 'filmQuery' })
    },
    onClick() {
      this.$router.push({ path: 'checkInfo' })
    },
    onForwarding() {
      this.$router.push({ path: '/remoteList' })
    }
  }
}
</script>
<style scoped>
@import '../../style/selectPatient/index.css';
</style>


